module.exports = __webpack_public_path__ + "static/homebanner-9b946e52ec9f96dba3b6f63aeb5df3ea.png";